// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderConfirmationShippingInformationStyles } from "@tps/Overrides/Widgets/OrderConfirmation/OrderConfirmationShippingInformation";
import { css } from "styled-components";

orderConfirmationShippingInformationStyles.shippingInformationGridContainer = {
    gap: 0,
};

orderConfirmationShippingInformationStyles.customPickup = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

orderConfirmationShippingInformationStyles.oneTimeAddressHeading = {
    forwardAs: "p",
    size: 14,
    weight: "bold",
    lineHeight: "22px",
    css: css`
        margin-bottom: 8px;
    `,
};
